import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import type { OwnerType } from '@never2busy/shared';
import { keywordsApi } from '../../api/endpoints/keywords';

interface KeywordFilterProps {
  ownerType: OwnerType;
  value?: number[];
  onChange?: (ids: number[]) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}

/** Multi-select de etiquetas para filtrar listas (AND). */
export function KeywordFilter({
  ownerType,
  value,
  onChange,
  placeholder = 'Filtrar por etiqueta…',
  style,
}: KeywordFilterProps): JSX.Element {
  const { data, isLoading } = useQuery({
    queryKey: ['keywords', 'list', ownerType],
    queryFn: () => keywordsApi.list(ownerType),
    staleTime: 60_000,
  });

  return (
    <Select
      mode="multiple"
      allowClear
      placeholder={placeholder}
      loading={isLoading}
      value={value}
      onChange={onChange}
      options={(data ?? []).map((k) => ({ label: k.text, value: k.id }))}
      style={{ minWidth: 200, ...style }}
      maxTagCount="responsive"
    />
  );
}
